import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/loading.svg'
import _imports_1 from '@/assets/check.svg'
import _imports_2 from '@/assets/cross.svg'
import _imports_3 from '@/assets/orange-dot.svg'


const _hoisted_1 = { class: "container statistics__filters" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "title-2" }, "Statistiques", -1)
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "title-2" }, "Filtres actifs", -1)
const _hoisted_6 = { class: "container statistics__filters__items" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "container" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title-2" }, "Fiches filtrées")
], -1)
const _hoisted_12 = { class: "list__items" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "d-flex items-baseline justify-between" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Télécharger ")
const _hoisted_16 = {
  key: 1,
  class: "spinner"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "UNUCR"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_22 = {
  key: 2,
  class: "icon",
  src: _imports_2,
  alt: ""
}
const _hoisted_23 = {
  key: 3,
  class: "icon",
  src: _imports_3,
  alt: ""
}

import Modal from "@/domains/app/components/Modal.vue";
import { ref } from "@vue/reactivity";
import { sheetColumns } from "../config";
import { Filter, PartialSheet, getParsedFilters, useFilters } from "../filters";
import Paginator from "@/domains/app/pagination/components/Paginator.vue";
import AddFilerModal from "./AddFilerModal.vue";
import { useUser } from "@/domains/auth/user";
import { computed, onUnmounted, watch } from "vue";
import {
    ABILITY_READ_DEP_STATISTICS,
    ABILITY_READ_ALL_STATISTICS,
    Ability,
} from "@/domains/cruds/users/users";
import View from "@/domains/cruds/sheets/components/View.vue";
import { FAILURE_IDS, SUCCESSFUL_IDS } from "@/domains/cruds/results/results";
import { request } from "@/domains/api/api";
import { useLoading } from "@/domains/app/loading";
import CsvToXslxWorker from "worker-loader!../worker";


export default /*#__PURE__*/_defineComponent({
  async setup(__props) {

let __temp: any, __restore: any

const previewId = ref<number | null>();
function onSheetFormClosed() {
    previewId.value = null;
}

const { appendFilter, removeFilter, filters, useSheetsNaviationState } =
    useFilters();

const addFilterModalOpened = ref(false);

const { user, onLogin } = useUser();
;(
  ([__temp,__restore] = _withAsyncContext(() => onLogin)),
  await __temp,
  __restore()
);

let hiddenFilter = ref<Filter | undefined>();
const selectedLevel = ref(0);
watch(
    selectedLevel,
    (level) => {
        if (!user.value) return;
        if (hiddenFilter.value) removeFilter(hiddenFilter.value);
        switch (level) {
            case 0:
                hiddenFilter.value = appendFilter(
                    "user_id",
                    "=",
                    "" + user.value.id,
                    ""
                );
                break;
            case 1:
                hiddenFilter.value = appendFilter(
                    "department_id",
                    "=",
                    "" + user.value.department_id,
                    ""
                );
                break;
        }
    },
    { immediate: true }
);

const {
    sheets: filteredSheets,
    total: totalFiltered,
    goToPage,
    nextPage,
    prevPage,
} = useSheetsNaviationState();

const statsLevel = computed(() => {
    const levels: Ability[] = [
        ABILITY_READ_DEP_STATISTICS,
        ABILITY_READ_ALL_STATISTICS,
    ];
    let score = 0;
    levels.every((l) => {
        if (user.value?.abilities?.includes(l)) {
            score++;
            return true;
        }
        return false;
    });
    return score;
});

function parseDate(date: Date | number | string | undefined) {
    if (!date) return "";
    const formatted = new Date(date);
    const day = formatted.getDate().toString().padStart(2, "0");
    const month = (formatted.getMonth() + 1).toString().padStart(2, "0");
    const year = formatted.getFullYear().toString().padStart(2, "0");
    return `${day}/${month}/${year}`;
}

function isSuccess(sheet: PartialSheet) {
    if (!sheet.result_id) return false;
    return SUCCESSFUL_IDS.includes(sheet.result_id);
}

function isFailure(sheet: PartialSheet) {
    if (!sheet.result_id) return false;
    return FAILURE_IDS.includes(sheet.result_id);
}

const { loading: downloadLoading, setLoading: setDownloadLoading } =
    useLoading("download-sheets");
const downloadError = ref<string | null>(null);

let abortDownload: (() => void) | null = null;
onUnmounted(() => {
    if (abortDownload) abortDownload();
});

function downloadSheets() {
    if (downloadLoading.value) return;
    downloadError.value = null;
    setDownloadLoading(true);

    request<string>(
        "exports/sheets",
        "get",
        () => (downloadError.value = "Une erreur est survenue"),
        getParsedFilters(useFilters().filters.value)
    )
        .then((rs) => {
            if (!rs) {
                downloadError.value = "Aucune fiche trouvée";
                return;
            }
            return new Promise<void>((resolve, reject) => {
                const worker = new CsvToXslxWorker();
                worker.onmessage = (event: MessageEvent) => {
                    const objectUrl = event.data;
                    const a = document.createElement("a");
                    a.href = objectUrl;
                    a.download = "fiches.xlsx";
                    a.click();
                    setTimeout(() => {
                        window.URL.revokeObjectURL(objectUrl);
                    }, 500);
                    worker.terminate();
                    abortDownload = null;
                    resolve();
                };
                worker.onerror = () => {
                    worker.terminate();
                    abortDownload = null;
                    reject();
                };
                worker.postMessage(rs);
                abortDownload = () => {
                    worker.terminate();
                    abortDownload = null;
                    reject();
                };
            });
        })
        .catch((e) => {
            console.error(e);
            downloadError.value = "Une erreur est survenue";
        })
        .finally(() => setDownloadLoading(false));
}

return (_ctx: any,_cache: any) => {
  const _directive_loading_key = _resolveDirective("loading-key")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(statsLevel) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn", {
                        'btn-secondary': selectedLevel.value === 0,
                        'btn-light': selectedLevel.value !== 0,
                    }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedLevel.value = 0))
              }, " Les miennes ", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["btn ms-1", {
                        'btn-secondary': selectedLevel.value === 1,
                        'btn-light': selectedLevel.value !== 1,
                    }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedLevel.value = 1))
              }, " Département ", 2),
              (_unref(statsLevel) > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(["btn ms-1", {
                        'btn-secondary': selectedLevel.value === 2,
                        'btn-light': selectedLevel.value !== 2,
                    }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedLevel.value = 2))
                  }, " National ", 2))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters), (filter, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (filter !== _unref(hiddenFilter))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_unref(sheetColumns)[filter.col]?.trad || filter.col) + " " + _toDisplayString(filter.type !== "range" ? filter.type : "=") + " " + _toDisplayString(filter.visibleValue) + " ", 1),
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_unref(removeFilter)(filter)),
                    class: "btn"
                  }, "X", 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (addFilterModalOpened.value)
          ? (_openBlock(), _createBlock(AddFilerModal, {
              key: 0,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (addFilterModalOpened.value = false)),
              "user-level": selectedLevel.value,
              onAddFilter: _cache[4] || (_cache[4] = 
                    (f) => _unref(appendFilter)(f.col, f.type, f.value, f.visibleValue)
                )
            }, null, 8, ["user-level"]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (addFilterModalOpened.value = !addFilterModalOpened.value))
        }, " Ajouter un filtre ")
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
        (downloadError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(downloadError.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", null, "Nombre de fiches: " + _toDisplayString(_unref(totalFiltered) || 0), 1),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (downloadSheets()))
          }, [
            (!_unref(downloadLoading))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_15
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredSheets), (sheet) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "list-item",
            key: sheet.id,
            onClick: ($event: any) => (previewId.value = sheet.id)
          }, [
            _createElementVNode("span", null, _toDisplayString(parseDate(sheet.date)), 1),
            (sheet.game)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(sheet.game.label), 1))
              : _createCommentVNode("", true),
            (isSuccess(sheet))
              ? (_openBlock(), _createElementBlock("img", _hoisted_21))
              : (isFailure(sheet))
                ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                : (_openBlock(), _createElementBlock("img", _hoisted_23))
          ], 8, _hoisted_19))
        }), 128))
      ])), [
        [_directive_loading_key, 'statistics.sheets']
      ]),
      (_unref(totalFiltered) !== null && _unref(totalFiltered) > 10)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            pages: _unref(totalFiltered) / 10,
            "onNavigate:next": _cache[7] || (_cache[7] = ($event: any) => (_unref(nextPage)())),
            "onNavigate:prev": _cache[8] || (_cache[8] = ($event: any) => (_unref(prevPage)())),
            "onNavigate:to": _unref(goToPage)
          }, null, 8, ["pages", "onNavigate:to"]))
        : _createCommentVNode("", true)
    ]),
    (previewId.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          cancel: null,
          confirm: { text: 'Fermer' },
          onExit: onSheetFormClosed,
          onConfirm: onSheetFormClosed
        }, {
          default: _withCtx(() => [
            _createVNode(View, { id: previewId.value }, null, 8, ["id"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})